import { load } from '../static/js/zjs'

export function getCommentCount() {
  //   load(
  //     'https://cy-cdn.kuaizhan.com/upload/plugins/plugins.list.count.js?clientId=cytJtxFUW',
  //     {
  //       id: 'cy_cmt_num'
  //     },
  //     function() {}
  //   )
}
export function getCommentComponent() {
  //   load(
  //     'https://cy-cdn.kuaizhan.com/upload/mobile/wap-js/changyan_mobile.js?client_id=cytJtxFUW&conf=prod_3b34206430f83eb3d219299033aaf6db',
  //     {
  //       id: 'changyan_mobile_js'
  //     },
  //     function() {}
  //   )
}
